export enum StoreFlag {
  SubjectToIIBBWithholding = 'subject-to-iibb-withholding',
  PlanAhoraGone = 'plan-ahora-gone',
  WebUnderConstructionEnabled = 'web-under-construction-enabled',
  SubscriptionsRecurrenceActive = 'subscriptions_recurrence_active',
  WithdrawBlockedByLending = 'withdraw_blocked_by_lending',
  NpLockInByLending = 'nuvempago_lock_in_by_lending',
}
